import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectUserOverview } from '@core/core.selectors';
import { filterSucceededResource } from '@platform/shared/resource.state';
import { UserOverview } from '@core/core.state';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserManagementComponent {
  public readonly users: Signal<UserOverview[]>;

  constructor(store$: Store) {
    this.users = toSignal(store$.pipe(select(selectUserOverview), filterSucceededResource()), { initialValue: [] });
  }
}
